// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qnq4","title":"styles_title__3vfeo"};